export const ADDRESS = 'ADDRESS';
export const STRING = 'STRING';
export const POSITIVE_NUMBER = 'POSITIVE_NUMBER';
export const BYTES32 = 'BYTES32';
export const RESOLVER = 'RESOLVER';

export const TRANSACTION_RECEIPT_FAILED = 'TRANSACTION_RECEIPT_FAILED';
